import PropTypes from 'prop-types';
import React from 'react';
import { getFormattedCityStateZip } from '../../shared/addressFormatter';

export class Address extends React.Component {
  renderAddressItem(item) {
    if (item && item !== '') {
      return <div {...this.props.otherProperties}>{item}</div>;
    }
    return null;
  }

  renderCityStateZip(city, state, zip) {
    const cityStateZip = getFormattedCityStateZip(city, state, zip);
    if (cityStateZip && cityStateZip !== '') {
      return <div {...this.props.otherProperties}>{cityStateZip}</div>;
    }
    return null;
  }

  render() {
    return (
      <div className="person-address">
      {this.renderAddressItem(this.props.address.institution)}
      {this.renderAddressItem(this.props.address.address1)}
      {this.props.isShowShortAddress ? null : this.renderAddressItem(this.props.address.address2)}
      {this.props.isShowShortAddress ? null : this.renderAddressItem(this.props.address.address3)}
      {this.renderCityStateZip(this.props.address.city,
                              this.props.address.state,
                              this.props.address.zipCode)}
      </div>
    );
  }
}

Address.propTypes = {
  address: PropTypes.object.isRequired,
  isShowShortAddress: PropTypes.bool,
  otherProperties: PropTypes.object,
};